import {Container, Grid, Paper, TableBody, TableHead} from "@mui/material";
import {
    StyledButtonContainer,
    StyledButtonOrange,
    StyledTable, StyledTableBodyRow,
    StyledTableCell, StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import * as DataProvider from "../../logic/DataProvider";
import {GetLookupValueName} from "../../logic/LookupHelper";
import {useNavigate} from "react-router-dom";


const WalletsPage = () => {
    const navigate = useNavigate();
    const [wallets, setWallets] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            if (bundle.wallets) {
                let entities = bundle.wallets;
                setWallets(JSON.parse(JSON.stringify(entities)));
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleRequestNew = () => {
        navigate(`request`);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <StyledButtonContainer container>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={handleRequestNew}>
                        New
                    </StyledButtonOrange>
                </Grid>
            </StyledButtonContainer>
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={3}>Asset</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={3}>Address</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={3}>Multisig</StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {wallets && wallets.map((wallet) => (
                            <StyledTableBodyRow key={wallet.id}>
                                <StyledTableCell>{GetLookupValueName('asset', wallet.assetId)}</StyledTableCell>
                                <StyledTableCell>{wallet.address}</StyledTableCell>
                                <StyledTableCell>{wallet.isMultisig ? 'Yes' : 'No'}</StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Container>
    );
};
export default WalletsPage;